import { Table } from "semantic-ui-react";
import { TitleView } from "../../../../components";
import { checkValueIsEmpty } from "../../../../utils/utils";

const Ingredient = ({ IngredientData }: any) => {
  return (
    <>
      <TitleView title="Ingredient" />
      <Table celled className="table" structured>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="tableHeader" colSpan="1" textAlign="center">
              Ingredient
            </Table.HeaderCell>
            <Table.HeaderCell
              className="tableHeader"
              colSpan="15"
              textAlign="center"
              style={{ backgroundColor: "#f4c6db", color: "#000" }}
            >
              Input field
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell className="tableHeaderReview">Ingredient Name</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Supplier Name</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Ingredient Type</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Data Type </Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Unit Size</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Unit Type</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">EAN Barcode</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {IngredientData?.map((data: any) => {
            return (
              <Table.Row>
                <Table.Cell>{data?.ingredient_id?.ingredient_name}</Table.Cell>
                <Table.Cell>{data?.supplier_id?.supplier_name}</Table.Cell>
                <Table.Cell className={checkValueIsEmpty(data?.ingredient_type)}>
                  {data?.ingredient_type || "Missing ingredient type"}
                </Table.Cell>
                <Table.Cell className={checkValueIsEmpty(data?.data_type)}>
                  {data?.data_type || "Missing data type"}
                </Table.Cell>
                <Table.Cell>{data?.unit_size}</Table.Cell>
                <Table.Cell>{data?.unit_type}</Table.Cell>
                <Table.Cell>{data?.ean_bar_code}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
};

export default Ingredient;
